import React from 'react';
import { ApplicationPaths } from './auth/constants';
function Home() {
    return (React.createElement("div", { className: "container" },
        React.createElement("h1", null, "Welcome"),
        React.createElement("p", null,
            "  ",
            React.createElement("button", { onClick: function () { return location.href = "#" + ApplicationPaths.Login; } }, "Go to Login"))));
}
export default Home;
